import React, { useMemo, useState } from 'react';

export default function ReadMore({text, limit = 300}) {
    const [isExpanded, setIsExpanded] = useState(false);
    
    if (!text) return null;
console.log("text", text)
    const paragraphs = useMemo(() => {
        const temp = document.createElement("div");
        temp.innerHTML = text;

        return Array.from(temp.querySelectorAll("p")).map(
            p => p.textContent || ""
        )
    }, [text]);

    const fullText = paragraphs.join("\n\n");
    const isLongText = fullText.length > limit;
    const truncatedText =  (isExpanded || !isLongText) ? 
        fullText : fullText.slice(0, limit) + "...";

    const displayedParagraphs = useMemo(() => {
        return truncatedText.split("\n\n");
    }, [truncatedText]);

    return (
        <div className='read-more'>
            {displayedParagraphs.map((para, index) => (
                <p key={index}>{para}</p>
            ))}

            {/* {isLongText && (
                <button type='button' className='btn--link' onClick={() => setIsExpanded(!isExpanded)}>
                    {isExpanded ? "Show Less" : "More info"}
                </button>
            )} */}

            {(isLongText && !isExpanded) && (
                <button type='button' className='btn--more' onClick={() => setIsExpanded(!isExpanded)}>More info...</button>
            )}
        </div>
    )
}